/**
 * @copyright 2024-2026 David Baugh
 * @license Proprietary - All Rights Reserved
 * Unauthorized copying, modification, or distribution is strictly prohibited.
 */

import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import UserManagement from './UserManagement';
import StudentProgress from './StudentProgress';
import Dashboard from './Dashboard';
import TestManager from './TestManager';
import ClassEditor from './ClassEditor';
import ImageGallery from './ImageGallery';
import SystemConfig from './SystemConfig';
import LicenseBanner from './LicenseBanner';

const AdminPanel = () => {
  const [activeTab, setActiveTab] = useState('dashboard');

  return (
    <Card className="w-full max-w-[1400px] mx-auto"> {/* Increased max-width */}
      <CardHeader className="flex flex-row items-center justify-between">
        <CardTitle>Admin Panel</CardTitle>
      </CardHeader>
      <CardContent>
        <LicenseBanner />
        <Tabs value={activeTab} onValueChange={setActiveTab}>
          {/*
            Responsive tab bar: the base TabsList is a fixed-height (h-10) flex row,
            which crushes 7 tabs on a phone. Override to an auto-height grid that
            reflows — 2 cols on phone, 4 on small tablets, 7 in a single row at lg.
            auto-rows-[44px] keeps each tab a comfortable tap target while wrapping.
          */}
          <TabsList className="grid h-auto w-full auto-rows-[44px] grid-cols-2 gap-1 sm:grid-cols-4 lg:h-10 lg:auto-rows-auto lg:grid-cols-7 lg:gap-0">
            <TabsTrigger value="dashboard">Dashboard</TabsTrigger>
            <TabsTrigger value="progress">Student Progress</TabsTrigger>
            <TabsTrigger value="cohorts">Class Management</TabsTrigger>
            <TabsTrigger value="users">Users</TabsTrigger>
            <TabsTrigger value="manager">Test Manager</TabsTrigger>
            <TabsTrigger value="images">Image Gallery</TabsTrigger>
            <TabsTrigger value="config">System Config</TabsTrigger>
          </TabsList>
          <TabsContent value="dashboard">
            <Dashboard />
          </TabsContent>
          <TabsContent value="progress">
            <StudentProgress />
          </TabsContent>
          <TabsContent value="cohorts">
            <ClassEditor />
          </TabsContent>
          <TabsContent value="users">
            <UserManagement />
          </TabsContent>
          <TabsContent value="manager">
            <TestManager showInactive={true} />
          </TabsContent>
          <TabsContent value="images">
            <ImageGallery />
          </TabsContent>
          <TabsContent value="config">
            <SystemConfig />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};

export default AdminPanel;